/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleModel
         * @description
         * Model
         */

export class Session_AppleModel {
  epochTimestamp: any | null | undefined;
  expiresAt: any | null | undefined;
  merchantSessionIdentifier: string | null | undefined;
  nonce: string | null | undefined;
  merchantIdentifier: string | null | undefined;
  domainName: string | null | undefined;
  displayName: string | null | undefined;
  signature: string | null | undefined;

	constructor(
		epochTimestamp?: any, 
		expiresAt?: any, 
		merchantSessionIdentifier?: string, 
		nonce?: string, 
		merchantIdentifier?: string, 
		domainName?: string, 
		displayName?: string, 
		signature?: string
	) {
		this.epochTimestamp = epochTimestamp || null;
		this.expiresAt = expiresAt || null;
		this.merchantSessionIdentifier = merchantSessionIdentifier || null;
		this.nonce = nonce || null;
		this.merchantIdentifier = merchantIdentifier || null;
		this.domainName = domainName || null;
		this.displayName = displayName || null;
		this.signature = signature || null;
	}
}
